import { render, staticRenderFns } from "./ArticleDetail2.vue?vue&type=template&id=20335f7a&scoped=true"
import script from "./ArticleDetail2.vue?vue&type=script&lang=js"
export * from "./ArticleDetail2.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetail2.vue?vue&type=style&index=0&id=20335f7a&prod&lang=css"
import style1 from "./ArticleDetail2.vue?vue&type=style&index=1&id=20335f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20335f7a",
  null
  
)

export default component.exports